var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompany = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#8B9095",
  fillRule: "evenodd",
  d: "M35.2 32.637v2.4H32v-2.4zm0-9.825v2.4H32v-2.4zm0-9.85v2.4H32v-2.4zM8 8v32h32V8zm29.6 29.6H10.4v-7.467h27.2zm0-9.867H10.4v-7.467h27.2zm0-9.867H10.4V10.4h27.2z"
})));
export { SvgCompany as ReactComponent };
export default __webpack_public_path__ + "static/media/company.93bdb0ba.svg";